import { render, staticRenderFns } from "./ImageOptimizerPopup.vue?vue&type=template&id=32d94bfa&scoped=true&"
import script from "./ImageOptimizerPopup.vue?vue&type=script&lang=js&"
export * from "./ImageOptimizerPopup.vue?vue&type=script&lang=js&"
import style0 from "./ImageOptimizerPopup.vue?vue&type=style&index=0&id=32d94bfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d94bfa",
  null
  
)

export default component.exports